export let AsyncStatus;
(function (AsyncStatus) {
  AsyncStatus["UNINITIALIZED"] = "UNINITIALIZED";
  AsyncStatus["PENDING"] = "PENDING";
  AsyncStatus["SUCCEEDED"] = "SUCCEEDED";
  AsyncStatus["FAILED"] = "FAILED";
})(AsyncStatus || (AsyncStatus = {}));
export const isLoading = asyncData => asyncData.status === AsyncStatus.PENDING || asyncData.status === AsyncStatus.UNINITIALIZED;
export const isFailed = asyncData => asyncData.status === AsyncStatus.FAILED;
export const isSucceeded = asyncData => asyncData.status === AsyncStatus.SUCCEEDED;